import * as types from '../constants/actionTypes';

const initialState = {
    isRegistered: false,
    //isVerified: false,
    isIdentified: false,
    agreedToTerms: false,
    email: "",
    emailConfirm: "",
    password: "",
    passwordConfirm: "",
    lastName: "",
    last4SSN: "",
    dobMonth: "",
    dobDay: "",
    dobYear: ""
}
  
const register = (state = initialState, action) => {

    switch (action.type) {
  
        case types.REGISTER_SUCCESS:
            return Object.assign({}, state, {
                visibilityFilter: action.filter
            });
        break;

        case types.REGISTER_ERROR:
            return Object.assign({}, state, {
                visibilityFilter: action.filter
            });
        break;

        case types.IDENTITY_SUCCESS:
            return Object.assign({}, state, {
                isIdentified: true
            });
        break;

        case types.PASSWORD_SUCCESS:
            return Object.assign({}, state, {
                passwordReset: true
            });
        break;

        case types.CLEAR_REG_STATE:
            return Object.assign({}, state, {
            isRegistered: false,
            isIdentified: false,
            passwordReset: false            
            });
        break;

      default:
        return state;
    }
    
}
  
export default register
  


// WEBPACK FOOTER //
// ./src/reducers/register.js